import { Button, Card, CardContent } from "alm-react-components";
import { useTranslation } from "react-i18next";
import { useContext, useEffect, useLayoutEffect, useState } from "react";
import AccordionArrowIcon from "../../../assets/images/svgicons/accordion-arrow.svg";
import PageLoader from "../../common/loader/PageLoader";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../context/AppProvider";
import {
  ActionType,
  SET_POPUP_TIMEOUT_DURATION,
} from "../../../assets/constants/constants";
import useIdleSessionTimer from "../../../hooks/useIdleSessionTimer";
import SessionTimeoutPopup from "../../common/SessionTimeoutPopup";

function PrivacyPolicy() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { state,dispatch } = useContext(AppContext);

  // Determine if the user is logged in (using token or access_token)
  const isLoggedIn = localStorage.getItem("access_token") !== null || localStorage.getItem("token") !== null;

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    if (history.scrollRestoration) {
      history.scrollRestoration = "manual";
    }
  }, [isLoggedIn]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000); 

    return () => clearTimeout(timer);
  }, []);

  //////  log user out after 1 hour of idleness

  // Callbacks to handle session timeout actions
  // Initialize the idle session timer with handlers
  const { resetTimers, logoutUser } = useIdleSessionTimer({
    timeout: SET_POPUP_TIMEOUT_DURATION,
    onIdle: handleIdle,
  });

  // Show the session timeout popup when user is idle
  function handleIdle() {
    dispatch({
      type: ActionType.SESSION_TIMEOUT_POPUP,
      payload: {
        visible: true,
        message: t("Common.sessionTimeoutAlertMessage"),
      },
    });
  }

  // Extend session and reset the timer when user clicks "Yes"
  const extendSessionTime = () => {
    resetTimers(); // Reset all timers and update lastActiveTimestamp
    dispatch({
      type: ActionType.SESSION_TIMEOUT_POPUP,
      payload: { visible: false, message: "" },
    });
  };

  // Logout user if session is not extended
  const handleLogout = () => {
    // Clear the context and navigate to the login page
    logoutUser();
    dispatch({
      type: ActionType.CLEAR_CONTEXT,
      payload: true,
    });
    // Force a full page reload to ensure clean logout
    navigate("/", { replace: true });
  };

  // Auto-logout when the popup timer expires
  const handleIdleTimeout = () => {
    handleLogout();
  };

  // Reset session popup visibility when logging in
  const handleLogin = () => {
    resetTimers(); // Reset timers on login
    dispatch({
      type: ActionType.SESSION_TIMEOUT_POPUP,
      payload: { visible: false, message: "" },
    });
  };

  useEffect(() => {
    // Call handleLogin when the page is loaded (e.g., after successful login)
    if (state?.user) {
      handleLogin();
    }
  }, [state?.user]);
  //

  return (
    <>
      {state.sessionTimeoutPopup && state.sessionTimeoutPopup?.visible && (
        <SessionTimeoutPopup
          onExtendSessionTime={extendSessionTime}
          onLogout={handleLogout}
          onIdleTimeout={handleIdleTimeout}
        />
      )}
      <div className="w-[100%] lg:w-[800px] mx-auto py-8 flex-grow">
        <Card className="bg-transparent dark:border-0 rounded-none">
          <CardContent>
            <div className="lg:flex lg:items-center lg:justify-between relative">
              <Button
                onClick={() => {
                  const redirectPaths = JSON.parse(localStorage.getItem('redirectPaths') || '')
                  const newRedirectPath = redirectPaths.pop();
                  localStorage.setItem('redirectPaths', JSON.stringify(redirectPaths));
                  newRedirectPath?.includes("library/library-course") ? navigate("/home/library"): navigate(newRedirectPath)
                }}
                variant="default"
                className="dark:bg-fillMidGrayCard w-6 h-6 pl-0 top-0 mt-[-28px] lg:mt-[6px] ml-[0px] lg:ml-[-40px] absolute"
              >
                <img
                  src={AccordionArrowIcon}
                  alt=""
                  aria-label="back"
                  className="logo cursor-pointer h-[14px] ml-4 rotate-180"
                />
              </Button>

              <div className="min-w-0 flex-1 md:pb-6 lg:pb-6">
                <h1
                  className="text-2xl lg:text-3xl font-barlowLight mb-4"
                  dangerouslySetInnerHTML={{
                    __html: t("Footer.termsOfService4"),
                  }}
                ></h1>

              </div>
            </div>

            <div className="w-full my-2 px-4 py-4 bg-white border border-gray-200 rounded-lg shadow dark:bg-fillLightGrayCard dark:border-gray-700">
              <div className="flow-root">
                {loading ? (
                  <PageLoader />
                ) : (
                  <div className="flow-root text-editor-dynamic-class">
                    <div
                      className="break-words"
                      dangerouslySetInnerHTML={{
                        __html: t("privacyAndPolicy.privacyPolicyContent"),
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
}

export default PrivacyPolicy;
